import JobListPage from './list/'
import JobAddPage from './add/'
import JobViewPage from './view/'

export default {
  JobListPage,
  JobViewPage,
  JobAddPage
}
